import React from 'react';
import DontBeBoxed from '../components/DontBeBoxed';
import TheMethod from '../components/TheMethod';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import GraduationBanner from '../components/GraduationBanner';

const Tuition = () => {
  return (
    <>
      <DontBeBoxed />
      <TheMethod />
      <Pricing />
      <Contact />
      <GraduationBanner />
    </>
  );
};

export default Tuition;
